import { render, staticRenderFns } from "./UsersIcon.vue?vue&type=template&id=27e790de&scoped=true&"
import script from "./UsersIcon.vue?vue&type=script&lang=js&"
export * from "./UsersIcon.vue?vue&type=script&lang=js&"
import style0 from "./UsersIcon.vue?vue&type=style&index=0&id=27e790de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e790de",
  null
  
)

export default component.exports